/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Provider } from '../models/Provider';

export class RegisterInputBillingToken {
  /**
  * The Marketplace token
  */
  'marketplaceToken'?: string;
  'marketplaceProvider'?: Provider;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "marketplaceToken",
      "baseName": "MarketplaceToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "marketplaceProvider",
      "baseName": "MarketplaceProvider",
      "type": "Provider",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RegisterInputBillingToken.attributeTypeMap;
  }

  public constructor() {
  }
}



